import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import DashboardHeader from '../../components/DashboardHeader';
import { useAuth } from '../../context/AuthContext';
import '../../App.css';

function HospitalPostings() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const filterType = searchParams.get('filter') || 'all';

  // Sample postings data
  const [allPostings] = useState([
    {
      id: 1,
      requirement: 'Junior Doctor',
      postedDate: '2025-11-21',
      periodFrom: '2025-12-01',
      periodTo: '2025-12-30',
      status: 'Active',
      responses: 3
    },
    {
      id: 2,
      requirement: 'Senior Doctor',
      postedDate: '2025-11-20',
      periodFrom: '2025-12-01',
      periodTo: '2025-12-30',
      status: 'Selected',
      responses: 5
    },
    {
      id: 3,
      requirement: 'Nurse',
      postedDate: '2025-11-15',
      periodFrom: '2025-12-15',
      periodTo: '2026-01-15',
      status: 'Selected',
      responses: 2
    },
    {
      id: 4,
      requirement: 'Pharmacist',
      postedDate: '2025-11-10',
      periodFrom: '2025-12-01',
      periodTo: '2025-12-31',
      status: 'Selected',
      responses: 4
    },
    {
      id: 5,
      requirement: 'Lab Technician',
      postedDate: '2025-10-28',
      periodFrom: '2025-11-20',
      periodTo: '2025-12-20',
      status: 'Selected',
      responses: 1
    }
  ]);

  const [filteredPostings, setFilteredPostings] = useState([]);

  // Filter postings based on filterType
  useEffect(() => {
    if (filterType === 'completed') {
      setFilteredPostings(allPostings.filter(posting => posting.status === 'Selected'));
    } else {
      setFilteredPostings(allPostings);
    }
  }, [filterType, allPostings]);

  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  // Get status badge class
  const getStatusBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'selected':
        return 'badge bg-success';
      case 'active':
        return 'badge bg-primary';
      case 'suspended':
        return 'badge bg-warning text-dark';
      default:
        return 'badge bg-secondary';
    }
  };

  return (
    <div className="App">
      <DashboardHeader
        userType="admin"
        userName={user?.displayName || 'Admin'}
      />

      <main className="dashboard-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="dashboard-title mb-0">
                  Hospital Postings
                  {filterType === 'completed' && <span className="ms-2 text-muted">(Completed)</span>}
                </h2>
                <div className="d-flex gap-2">
                  <button
                    className={`btn btn-sm ${filterType === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => navigate(`/admin/hospital-postings/${id}?filter=all`)}
                  >
                    All Postings
                  </button>
                  <button
                    className={`btn btn-sm ${filterType === 'completed' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => navigate(`/admin/hospital-postings/${id}?filter=completed`)}
                  >
                    Completed Postings
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => navigate('/admin/hospitals')}
                  >
                    Back to List
                  </button>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="table-light">
                        <tr>
                          <th scope="col">Sl#</th>
                          <th scope="col">Requirement</th>
                          <th scope="col">Posted Date</th>
                          <th scope="col">Period</th>
                          <th scope="col">Status</th>
                          <th scope="col">Responses</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredPostings.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center">No postings found</td>
                          </tr>
                        ) : (
                          filteredPostings.map((posting, index) => (
                            <tr key={posting.id}>
                              <td>{index + 1}</td>
                              <td>{posting.requirement}</td>
                              <td>{formatDate(posting.postedDate)}</td>
                              <td>
                                {formatDate(posting.periodFrom)} to {formatDate(posting.periodTo)}
                              </td>
                              <td>
                                <span className={getStatusBadgeClass(posting.status)}>
                                  {posting.status}
                                </span>
                              </td>
                              <td>{posting.responses}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default HospitalPostings;

